import { ReactElement, useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Lottie from 'react-lottie'
import { useAuth } from '../../hooks/auth'
import { LOCAL_EXECUTION } from '../../utils/featureFlag'
import * as notFoundAnimation from '../../assets/error-notfound.json'
import { ptBR } from 'date-fns/locale'
import {
  Container,
  FormDivider,
  PageSubtitle,
  PageTitle,
  TextHeaderBox,
  EventCard,
  ImgEvent,
  DividerH,
  CardTitle,
  CardDescription,
  CardContent,
  CardButton,
  ErrorBox,
  ExceptionContainer,
  PageHeaderBox,
} from './styles'
import Loader from '../../components/Loader'
import { DashboardhMediumButton, DashboardInput } from 'bd-web-components'
import { SECONDARY_BLUE_01 } from 'bd-web-components/src/utils/dash-colors'

import { parse, format, setDefaultOptions } from 'date-fns'
import pt from 'date-fns/locale/pt-BR'
import noImage from '../../assets/no-image-1970x700.png'
import { useEventsWithCourtesy } from '../../hooks/get-courtesy-events'
import { ButtonHeaderBox } from '../AddAccount/styles'

export function EventsCourtesy(): ReactElement {
  window.document.title = 'Lista de eventos'
  const authContext = useAuth()
  const navigate = useNavigate()
  const { authHookWithOutEvent } = authContext

  const [name, setName] = useState<string>('')
  const [data, setData] = useState<any>([])

  setDefaultOptions({ locale: pt })

  // AUTH SECTION
  if (!LOCAL_EXECUTION) {
    authHookWithOutEvent()
  }

  const { courtesyEvents, courtesyEventsLoading, courtesyEventsError } =
    useEventsWithCourtesy()

  const filterByName = (arr: typeof data, str: string) =>
    !str
      ? arr
      : arr.filter((e: any) =>
          e.event_name.toLowerCase().includes(str.toLowerCase())
        )

  useEffect(() => {
    if (courtesyEvents !== undefined) {
      setData(courtesyEvents)
    }
  }, [courtesyEvents, courtesyEventsLoading, courtesyEventsError])
  console.log(courtesyEvents, courtesyEventsLoading, courtesyEventsError)

  return (
    <>
      <Container>
        <PageHeaderBox>
          <TextHeaderBox>
            <PageTitle>{'Eventos'}</PageTitle>
            <PageSubtitle>
              {'Visualize todos os seus eventos que possuem cortesias.'}
            </PageSubtitle>
          </TextHeaderBox>
          <ButtonHeaderBox>
            <DashboardInput
              type={'input'}
              name={'searchName'}
              placeholder={'Buscar evento'}
              onChange={(e: any) => {
                setName(e.target.value)
              }}
            />
          </ButtonHeaderBox>
        </PageHeaderBox>
        <FormDivider />
        <br />
        <br />
        {data[0] !== undefined &&
          filterByName(data, name).map((event: any) => (
            <EventCard>
              <ImgEvent
                src={event.imgUrl}
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null
                  currentTarget.src = noImage
                }}
              />
              <CardContent>
                <CardTitle>{event.event_name}</CardTitle>
                <CardDescription>
                  {format(
                    parse(event.event_date, 'dd/MM/yyyy', new Date()),
                    "dd 'de' MMMM, yyyy",
                    { locale: ptBR }
                  )}
                  <DividerH />
                  {event.event_place}
                </CardDescription>
              </CardContent>
              <CardButton>
                <DashboardhMediumButton
                  onClick={() => navigate(`/events/${event.event_id}/courtesy`)}
                  color="#fff"
                  background={SECONDARY_BLUE_01}
                  height="48px"
                  maxWidth="100%"
                  variant="contained"
                >
                  {'Enviar Cortesias'}
                </DashboardhMediumButton>
              </CardButton>
            </EventCard>
          ))}

        {courtesyEventsError !== undefined &&
          courtesyEventsLoading === false &&
          data?.length === 0 && (
            <>
              <EventCard className="error">
                <ErrorBox>
                  <Lottie
                    options={{
                      loop: false,
                      autoplay: true,
                      animationData: notFoundAnimation,
                      rendererSettings: {
                        preserveAspectRatio: 'xMidYMid slice',
                      },
                    }}
                    isStopped={false}
                    isPaused={false}
                  />
                </ErrorBox>
                <CardContent>
                  <CardTitle className="error">
                    {'Nenhum evento foi encontrado '}
                  </CardTitle>
                  <CardDescription className="error">
                    Caso esteja com algum erro, entre em contato com o
                    comercial.
                  </CardDescription>
                </CardContent>
              </EventCard>
            </>
          )}

        {courtesyEventsError === undefined &&
          courtesyEventsLoading === true &&
          data?.length === 0 && (
            <ExceptionContainer height={100} margin={false}>
              <Loader />
            </ExceptionContainer>
          )}
      </Container>
    </>
  )
}
